export default __webpack_public_path__ + "static/media/IF_MyTeamStrengths_StrengthDesc_08.12897461.jpg";